import { encryptionSets } from '../../constants/encryption-sets'
import { shakeAndBangSets } from '../../constants/shake-and-band-sets';
import { secretWords } from '../../constants'

import { getQuickEncryptionConfig } from '../../lib/cryptic'
import { Fragment } from 'react';
import { useGetter } from 'vuex-react';

export const QuickEncryptionConfig = () => {
  const [currentConfig, setCurrentConfig] = useGetter('encryptionConfig/config');

  const inputsList = [
    { name: "secretWord", max: secretWords.length - 1, min: 0, value: currentConfig[0] },
    { name: "encryptionSet", max: encryptionSets.length - 1, min: 0, value: currentConfig[1] },
    { name: "shakeAndBangSet", max: shakeAndBangSets.length - 1, min: 0, value: currentConfig[2] },
  ]

  const handleChange = () => {
    const updatedInputs = inputsList.reduce((acc, { name }) => {
      const inputElement = document.querySelector(`input[name="${name}"]`);
      if (inputElement) {
        acc[name] = parseInt(inputElement.value, 10);
      }
      return acc;
    }, {});

    const { secretWord, encryptionSet, shakeAndBangSet } = updatedInputs;

    localStorage.setItem("SECRET_WORD", secretWords[secretWord] || secretWords[0]);
    localStorage.setItem("ENCRYPTION_SET", encryptionSets[encryptionSet].name);
    localStorage.setItem("SHAKE_AND_BANG_SET", shakeAndBangSets[shakeAndBangSet].name);

    setCurrentConfig(getQuickEncryptionConfig("array"));
  }

  return (
    <div className="quick-encryption-config-settings">
      {inputsList.map(({ name, max, min, value }, index) => (
        <Fragment key={name}>
          {index > 0 && '/'}
          <input
            type="number"
            name={name}
            min={min}
            max={max}
            value={value}
            onChange={handleChange}
          />
        </Fragment>
      ))}
    </div>
  )
}
